/** @format */

import styled from "styled-components"
import MemoSvgIconBoostAlert from "@local/icons/component/IconBoostAlert"
import { colorPalette } from "@ui-library/myslpro"
import { colorPalette as colorPalette2 } from "_shared/styles/color";
import MemoSvgIconBoostList from "@local/icons/component/IconBoostListe"
import { SkeletonLoaderButton, SkeletonLoaderDiv, SkeletonLoaderText } from "_shared/styles/skeletonLoader"

export const Container = styled.div`
	display: flex;
	width: 453px;
	padding: 16px 0px;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	align-self: stretch;
	margin: auto;
	.stats {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
		margin-left: 125px;
	}
	
	.p {
		color: ${colorPalette.greyDark};
		font-family: Source Sans Pro;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 22px
		width: 337px;
		margin: 0px;
	}
	
	.divider {
		background-color: #dddddd;
		height: 1px;
		position: relative;
		width: 338px;
	}
	
`

export const IconBoostAlert = styled(MemoSvgIconBoostAlert)`
	width: 54px;
	height: 54px;
`
export const IconBoostListe = styled(MemoSvgIconBoostList)`
	width: 54px;
	height: 54px;
`

export const TextWrapper = styled(SkeletonLoaderDiv)`
	color: ${colorPalette.greyDark};
	font-family: Source Sans Pro;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 24px;
`;

export const Text = styled(SkeletonLoaderText)`

	color: ${colorPalette.greyDark};
	font-family: Source Sans Pro;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 22px
	width: 337px;
	margin: 0px;
`;

export const ConsumptionValue = styled(SkeletonLoaderDiv)`
	color: ${colorPalette.secondary};
	font-family: Source Sans Pro;
	font-size: 32px;
	font-style: normal;
	font-weight: 700;
	line-height: 40px;

`;

export const Info = styled(SkeletonLoaderDiv)`
	align-items: center;
	display: inline-flex;
	flex: 0 0 auto;
	gap: 8px;
	${props => props.isLoading && 'margin-bottom: 5px'}
`;

export const IconContainer = styled(SkeletonLoaderDiv)`
	width: 60px;
	border-radius: 0px;
`;

export const ActionButton = styled(SkeletonLoaderButton)<{ tertiaryButtonBorder?: boolean}>`
	${props => props.isLoading && 'cursor: auto;'}
	${props => props.tertiaryButtonBorder && 'border: 2px solid #707070;'}
`;

export const ActionText = styled(SkeletonLoaderText)`
	${props => props.isLoading && 'pointer-events: none;'}
	color: ${colorPalette2.saphir};
	font-weight: bold;
	font-size: 16px;
	${props => !props.isLoading && 'margin: unset;'}
	${props => props.isLoading && 'margin-top : 5px;'}
	cursor: pointer;
	

	&:hover {
		text-decoration: underline;
	}
 `;